import * as tslib_1 from "tslib";
import { action } from 'satcheljs/lib/legacy';
import { composeStore } from 'owa-mail-compose-store';
import { lazyNewMessage } from 'owa-mail-message-actions';
// VSO 29687: Check if a new message is in the process of being created,
// and if not (or complete), create a new message
export default action('checkAndCreateNewMessage')(function checkAndCreateNewMessage(actionSource, targetId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!composeStore.newMessageCreationInProgress) return [3 /*break*/, 4];
                    composeStore.newMessageCreationInProgress = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, lazyNewMessage.importAndExecute(actionSource, targetId)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    composeStore.newMessageCreationInProgress = false;
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=checkAndCreateNewMessage.js.map